import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Platform } from '@ionic/angular';
import { TranslateService } from './services/translate.service';

import { NotificationTriggerService } from './services/notification-trigger.service';
import { VersionService } from './services/version.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  version = VersionService.version;
  isVersionMismatch = false;
  isAppLoading = true;
  public apisDone = false;

  constructor(
    private translateService: TranslateService,
    private router: Router, private notify: NotificationTriggerService,
    public versionService: VersionService, private platform: Platform,
    private authService: AuthService,
  ) {
    this.translateService.loadTranslations();
    document.body.classList.remove('dark');
    this.setupDeepLinkListener();
    this.initializeApp();
  }

  async ngOnInit() {
    await this.runInitialApis();
  }

  onSplashAnimationComplete(): void {
    this.isAppLoading = false;
  }

  private async runInitialApis(): Promise<void> {
    try {
      await Promise.allSettled([
        this.checkAppVersion(),
        this.authService.getLoggedInEmployee(),
      ]);
    } catch (err) {
      console.error('AppComponent: runInitialApis error', err);
    } finally {
      this.apisDone = true;
    }
  }


  initializeApp() {
    if (this.platform.is('android') || this.platform.is('ios') || this.platform.is('capacitor')) {
      this.notify.initializeFCMSoundChannel();
    }
  }

  async setupDeepLinkListener() {
    if (this.platform.is('android') || this.platform.is('ios') || this.platform.is('capacitor')) {
      const currentUrl = window.location.href;
      if (currentUrl.includes('code=')) {
        this.handleUrl(currentUrl);
      }

      App.addListener('appUrlOpen', async (data: any) => {
        this.handleUrl(data?.url);
      });
    }
  }

  private async handleUrl(url: string | undefined) {
    try {
      if (!url) return;
      try {
        let path = '';
        if (url.includes('://')) {
          const incoming = new URL(url);
          path = incoming.pathname + incoming.search;
        } else {
          path = url;
        }

        const deeplinkablePrefixes = ['/register'];
        const match = deeplinkablePrefixes.find(p => path.startsWith(p));
        if (match) {
          console.log('Deep link match found, navigating to:', path);
          await this.router.navigateByUrl(path, { replaceUrl: true });
        }
      } catch (e) {
        console.warn('Failed to parse deep link URL:', url, e);
      }
    } catch (outer) {
      console.error('handleUrl error:', outer);
    }
  }

  async checkAppVersion() {
    await this.versionService.getLatestVersion();
    const latestVersion = this.versionService?.versionData?.version_number;
    console.log('Check Version - Current:', this.version, 'Latest:', latestVersion);

    if (latestVersion && this.version != latestVersion) {
      console.warn('⚠️ Version mismatch detected!');
      this.isVersionMismatch = true;
    } else {
      this.isVersionMismatch = false;
    }
  }
}
